<script>
import { required } from 'vuelidate/lib/validators'
export default {
  name: 'shared.reference.step',
  props: {
    value: { type: Object, default: () => {} }
  },
  data: vm => ({
    form: {
      reference: '',
      ...vm.value
    }
  }),
  validations: {
    form: {
      reference: {
        required
      }
    }
  },
  methods: {
    validate () {
      if (!this.$v && !this.$v.form) return true
      this.$v.form.$touch()
      if (!this.$v.form.$invalid) {
        this.$emit('validated', {
          reference: this.form.reference
        })
        this.$emit('input', {
          reference: this.form.reference
        })
      }

      return !this.$v.form.$invalid
    }
  }
}
</script>
<template>
  <b-card no-body class="shadow-none">
    <g-form-error-wrapper :validations="$v.form.reference">
      <template v-slot="{ errors, invalid }">
        <g-text-input
          v-model="form.reference"
          :label="$t('Your Reference')"
          :placeholder="$t('Your reference. i.e. po number, patient name')"
          :error-messages="errors"
          :is-valid="!invalid"
          v-on:blur="$v.form.reference.$touch()"
        >
        </g-text-input>
      </template>
    </g-form-error-wrapper>
  </b-card>
</template>
